module.exports = __webpack_public_path__ + "img/pe.6227fa63.svg";